export class FeedBackVo {
    negFeedback: string[] = [];
    posFeedback: string[] = [];
    score: number = 0;
    letterGrade: string = '';
    constructor(posFeedback: string[],negFeedback:string[], score: number, letterGrade: string) {
        this.posFeedback = posFeedback;
        this.negFeedback = negFeedback;
        this.score = score;
        this.letterGrade = letterGrade;
    }
}